export default "__VITE_ASSET__CwjLBEEB__"